class Faqs2 extends window.HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.filterItems = Array.from(this.querySelectorAll('.filter-item'));
    this.faqItems = Array.from(this.querySelectorAll('.faq-item'));
    this.searchInput = this.querySelector('.faqs-search-ipt');
    this.searchResult = this.querySelector('.search-result');

    this.questions = this.faqItems.map((item) => ({
      tags: item.dataset.filter || '',
      question: this.getQuestionText(item),
    }));

    this.bindFilterEvents();
    this.bindQuestionEvents();
    this.bindSearchEvents();
    this.bindOutsideClick();
    this.init();
  }

  init() {
    this.closeAllItems();

    if (!this.filterItems.length) {
      this.faqItems.forEach((item, index) => {
        item.style.display = 'block';
        if (index === 0) this.openItem(item);
      });
      return;
    }

    this.activateFilter(this.filterItems[0].dataset.filter || '');
  }

  getQuestionText(item) {
    const title = item.querySelector('.faq-title');
    return title ? title.textContent.trim() : '';
  }

  bindFilterEvents() {
    this.filterItems.forEach((filterItem) => {
      filterItem.addEventListener('click', () => {
        this.activateFilter(filterItem.dataset.filter || '');
      });
    });
  }

  bindQuestionEvents() {
    this.faqItems.forEach((item) => {
      const title = item.querySelector('.faq-title');
      if (!title) return;

      title.addEventListener('click', () => {
        const isActive = item.classList.contains('active-qa');
        this.closeAllItems();
        if (!isActive) {
          this.openItem(item);
        }
      });
    });
  }

  bindSearchEvents() {
    if (!this.searchInput || !this.searchResult) return;

    this.searchInput.addEventListener('input', () => {
      this.renderSearchResults(this.searchInput.value);
    });

    this.searchResult.addEventListener('click', (event) => {
      const resultItem = event.target.closest('.search-result-item');
      if (!resultItem) return;

      const targetTag = resultItem.dataset.filter || '';
      const targetQuestion = resultItem.dataset.question || resultItem.textContent.trim();

      this.searchInput.value = '';
      this.clearSearchResults();
      this.activateFilter(targetTag, targetQuestion);
    });
  }

  bindOutsideClick() {
    document.addEventListener('click', (event) => {
      if (this.contains(event.target)) return;
      this.clearSearchResults();
    });
  }

  activateFilter(tag, questionToOpen) {
    this.filterItems.forEach((filterItem) => {
      filterItem.classList.toggle('filter-active', (filterItem.dataset.filter || '') === tag);
    });

    let firstVisibleItem = null;
    let matchedQuestionItem = null;

    this.faqItems.forEach((item) => {
      const isMatch = !tag || (item.dataset.filter || '') === tag;
      item.style.display = isMatch ? 'block' : 'none';

      if (isMatch && !firstVisibleItem) {
        firstVisibleItem = item;
      }

      if (isMatch && questionToOpen && this.getQuestionText(item) === questionToOpen) {
        matchedQuestionItem = item;
      }
    });

    this.closeAllItems();

    const itemToOpen = matchedQuestionItem || firstVisibleItem;
    if (itemToOpen) {
      this.openItem(itemToOpen);
    }
  }

  openItem(item) {
    const answer = item.querySelector('.faq-answer');
    const openIcon = item.querySelector('.open');
    const closeIcon = item.querySelector('.close');

    if (!answer) return;

    item.classList.add('active-qa');
    answer.style.maxHeight = answer.scrollHeight + 20 + 'px';
    answer.style.padding = '0 0 20px 0';

    if (openIcon) openIcon.style.display = 'none';
    if (closeIcon) closeIcon.style.display = 'block';
  }

  closeAllItems() {
    this.faqItems.forEach((item) => {
      const answer = item.querySelector('.faq-answer');
      const openIcon = item.querySelector('.open');
      const closeIcon = item.querySelector('.close');

      item.classList.remove('active-qa');

      if (answer) {
        answer.style.maxHeight = '0';
        answer.style.padding = '0';
      }

      if (openIcon) openIcon.style.display = 'block';
      if (closeIcon) closeIcon.style.display = 'none';
    });
  }

  renderSearchResults(value) {
    if (!this.searchResult) return;

    const keyword = value.trim().toLowerCase();
    this.clearSearchResults();

    if (!keyword) return;

    const matchedQuestions = this.questions.filter((item) =>
      item.question.toLowerCase().includes(keyword)
    );

    if (!matchedQuestions.length) {
      const emptyResult = document.createElement('div');
      emptyResult.className = 'result-blank';
      emptyResult.textContent = 'No results found. Please try your search again.';
      this.searchResult.appendChild(emptyResult);
      return;
    }

    const fragment = document.createDocumentFragment();
    matchedQuestions.forEach((item) => {
      const resultItem = document.createElement('div');
      resultItem.className = 'search-result-item';
      resultItem.dataset.filter = item.tags;
      resultItem.dataset.question = item.question;
      resultItem.textContent = item.question;
      fragment.appendChild(resultItem);
    });

    this.searchResult.appendChild(fragment);
  }

  clearSearchResults() {
    if (this.searchResult) {
      this.searchResult.innerHTML = '';
    }
  }
}

if (!window.customElements.get('faqs-2')) {
  window.customElements.define('faqs-2', Faqs2);
}
  